
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SessionOptionsService } from '../../../core/services/session-option.service';

@Component({
  selector: 'app-details-footer-window',
  standalone: true,
  imports: [],
  templateUrl: './details-footer-window.component.html',
  styleUrls: ['./details-footer-window.component.css']
})
export class DetailsFooterWindowComponent implements OnInit {
  @Input() mapEntity: any;
  @Input() sessionMode: any;
  @Output() commandClicked = new EventEmitter<any>();

  commands: any[] = [];

  constructor(private sessionOptionsService: SessionOptionsService) {}

  ngOnInit() {
    if (!this.mapEntity) return;

    // Use getCommands() if available, else fallback to commands property
    const arcLiveEntity = this.mapEntity.arcLiveMapEntity || this.mapEntity;
    const allCommands = typeof arcLiveEntity.getCommands === 'function'
      ? arcLiveEntity.getCommands()
      : Array.isArray(arcLiveEntity.commands) ? arcLiveEntity.commands : [];

    const mode = this.sessionOptionsService.getMode();
    for (const command of allCommands) {
      if (command.shouldShow ? command.shouldShow(mode) : true) {
        this.commands.push(command);
        if (typeof command.init === 'function') {
          command.init(arcLiveEntity);
        }
      }
    }
  }

  onCommandClick(index: number , mapEntity:any) {
    this.commandClicked.emit(this.commands[index]);
    this.commands[index].execute(mapEntity);
  }
}